import mediaQuery from 'styled-media-query'

// @ts-expect-error
export const mediaPc = mediaQuery.greaterThan('769px')
// @ts-expect-error
export const mediaPcForLiveTalk = mediaQuery.greaterThan('918px')
